import Issues from '@src/main/modules/parameters/ui/issues/Issues';

const IssuesPage = () => <Issues />;

export default IssuesPage;
